<div class="col text-center">
    <div class="row justify-content-center">
        <div class="dialog-title-box">
            <div class="col">
                <div class="row">
                    <div class="col pt-3">
                        <i  class=" icon" id="questionIcon"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col pb-3 pt-3">
                        <span id="confirmation" class="title pb-1 mt-3 mb-3">
                            Question Paper 
                        </span>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<img [src]="data" height="auto">
